import { forwardRef, React, useEffect, useImperativeHandle, useRef, useState } from 'react';
import styled, { keyframes, css } from 'styled-components';

import AccountInput from '../../../Component/AccountComponent/AccountInput.js';
import SignUpIdInput from '../../../Component/AccountComponent/SignUpIdInput.js';
import SignUpPwInput from '../../../Component/AccountComponent/SignUpPwInput.js';
import FetchModule from '../../Share/Network/FetchModule.js';

const SignUpInfo1 = forwardRef((props, ref) => {
	const [ownerClickCount, setOwnerClickCount] = useState(0);
	const [idClickCount, setIdClickCount] = useState(0);
	const [pwClickCount, setPwClickCount] = useState(0);
	const [availableOfId, setAvailableOfId] = useState(false);
	const [certifiedId, setCertifiedId] = useState('');
	const [isBlankId, setIsBlankId] = useState(true);
	const [idPlanation, setIdPlanation] = useState('필수항목을 입력해주세요');
	const [isClicked, setIsClicked] = useState(false); 
	const [isAnimate, setIsAnimate] = useState(false);

	const TopLevelRef = useRef();
	const IdRef = useRef();
	const PWRef = useRef();
	const OwnerRef = useRef();
	const OwnerPlanationRef = useRef();
	const IdPlanationRef = useRef();
	const PwPlanationRef = useRef();

	useImperativeHandle(ref, () => ({
		enableEnterAnimation: () => {
			setIsAnimate(true);
		},
		disableEnterAnimation: () => {
			setIsAnimate(false);
		},
		setOpacity: (val) => {
			TopLevelRef.current.style.opacity = val;
		},
		setLocation: (val) => {
			TopLevelRef.current.style.transform = `translateX(${val}%)`;
		},
		getOwnerName: () => {
			return OwnerRef.current.getValue();
		},
		getUserId: () => {
			return IdRef.current.getValue();
		},
		getUserPw: () => {
			return PWRef.current.getValue();
		},
		getAvailableOfId: () => {
			return availableOfId;
		},
		getCertifiedId: () => {
			return certifiedId;
		},
		isBlankOwnerName: () => {
			OwnerRef.current.setDefaultPlaceholder('반드시 실명을 입력해주세요');
			OwnerRef.current.plusClickCount();
			OwnerPlanationRef.current.style.opacity = 1;
		},
		isBlankId: () => {
			setIsBlankId(true);
			IdRef.current.setDefaultPlaceholder('사용하실 아이디를 입력해주세요');
			IdRef.current.plusClickCount();
			IdPlanationRef.current.style.opacity = 1;
		},
		didNotCheckAvailableId: () => {
			setAvailableOfId(false);
			setIsBlankId(false);
			setIdPlanation('아이디 중복확인을 진행해 주세요.');
			IdPlanationRef.current.style.opacity = 1;
			IdPlanationRef.current.style.color = '#FF3131';
		},
		isBlankPassword: () => {
			PWRef.current.setDefaultPlaceholder('사용하실 패스워드를 입력해주세요');
			PWRef.current.plusClickCount();
			PwPlanationRef.current.style.opacity = 1;
		},
		// 패스워드 유효성 검증 (에러 표시하고 boolean 반환)
		isValidPassword: () => {
			const isValid = PWRef.current.isValidPassword();

			if (!isValid) {
				PwPlanationRef.current.innerText = '영문, 숫자, 특수문자 포함 6자리 이상 입력하세요';
				PwPlanationRef.current.style.opacity = 1;
				PwPlanationRef.current.style.color = '#FF3131';
			}
			else {
				PwPlanationRef.current.style.opacity = 0;
			}

			return isValid;
		}
	}));

	useEffect(() => {
		if (idClickCount === 0 && pwClickCount === 0 && ownerClickCount === 0) return;

		if (IdRef.current.getValue() === '' && idClickCount > 0) {
			IdPlanationRef.current.style.color = '#FF3131';
			IdPlanationRef.current.style.opacity = 1;
		}
		else {
			IdPlanationRef.current.style.opacity = 0;
		}
		
		// 비밀번호 유효성 검증 (실시간)
		const pw = PWRef.current.getValue();

		if (pwClickCount > 0) {
			if (pw === '') {
				PwPlanationRef.current.innerText = '필수항목을 입력해주세요';
				PwPlanationRef.current.style.color = '#FF3131';
				PwPlanationRef.current.style.opacity = 1;
			}
			else if (!isValidPassword(pw)) {
				PwPlanationRef.current.innerText = '영문, 숫자, 특수문자 포함 6자리 이상 입력하세요';
				PwPlanationRef.current.style.color = '#FF3131';
				PwPlanationRef.current.style.opacity = 1;
			}
			else {
				PwPlanationRef.current.style.opacity = 0;
			}
		}

		if (OwnerRef.current.getValue() === '' && ownerClickCount > 0) {
			OwnerPlanationRef.current.style.color = '#FF3131';
			OwnerPlanationRef.current.style.opacity = 1;
		}
		else {
			OwnerPlanationRef.current.style.opacity = 0;
		}
		
	}, [idClickCount, pwClickCount, ownerClickCount])

	// 비밀번호 유효성 검증 함수
	function isValidPassword(pw) {
		if (pw.length < 6) return false;
		if (!/[A-Za-z]/.test(pw)) return false;      // 영문
		if (!/[0-9]/.test(pw)) return false;         // 숫자
		if (!/[!@#$%^&*(),.?":{}|<>]/.test(pw)) return false; // 특수문자
		return true;
	}

	function clickCountFn(className, clickCount) {
		if (className === 'IdInput') setIdClickCount(clickCount);
		else if (className === 'PWInput') setPwClickCount(clickCount);
		else if (className === 'OwnerInput') setOwnerClickCount(clickCount);
	}

	// ID형식 확인 정규식
	function isAvailableId(asValue) {
		var regExp = /^[a-z]+[a-z0-9]{4,49}$/g;
 
		return regExp.test(asValue);
	}

	function duplicateCheck() {
		if (isClicked) return;

		var userId = IdRef.current.getValue();

		if (userId === '') { 
			IdRef.current.plusClickCount();
			IdRef.current.setDefaultPlaceholder('아이디를 입력해주세요');
			IdPlanationRef.current.style.color = '#FF3131';
			IdPlanationRef.current.style.opacity = 1;

			return;
		}
		else if (!isAvailableId(userId)) {
			// IdRef.current.plusClickCount();
			setIdPlanation('5~50자의 영문 소문자, 숫자와 특수기호(_),(-)만 사용 가능합니다.');
			IdPlanationRef.current.style.color = '#FF3131';
			IdPlanationRef.current.style.opacity = 1;
			setIsClicked(false);

			return;
		}

		setIsBlankId(false);

		const fetchModule = new FetchModule();
		(
			async () => {
				const responseData = await fetchModule.postData('account/asp/inspection/' + userId, 'POST');

				if (responseData.status === 200) {
					setAvailableOfId(true);
					setCertifiedId(userId);
					setIsClicked(true);
					setIdPlanation('사용가능한 아이디 입니다.');
					IdPlanationRef.current.style.color = '#FF8B48';
					IdPlanationRef.current.style.opacity = 1;
					// 중복확인 완료 후 border를 회색으로 리셋
					IdRef.current.reset('아이디를 입력해주세요');
				}
				else {
					setAvailableOfId(false);
					setIsClicked(false);

					if (isBlankId) {
						setIdPlanation('필수항목을 입력해주세요');
						IdRef.current.setDefaultPlaceholder('필수항목을 입력해주세요');
					}
					else {
						setIdPlanation('사용 불가능한 아이디 입니다.');
						IdRef.current.setDefaultPlaceholder('사용 불가능한 아이디 입니다.');
					}
					IdPlanationRef.current.style.color = '#FF3131';
					IdPlanationRef.current.style.opacity = 1;
				}
			}
		)();
	}

	return (
		<TopLevelWrapper ref={TopLevelRef} $animate={isAnimate}>
			<InputInfo>관리자 성함</InputInfo>
			<AccountInput ref={OwnerRef} className='OwnerInput' placeholder='반드시 실명을 입력해주세요' type='text' clickCountFn={clickCountFn}/>
			<AccountExplanation ref={OwnerPlanationRef}>필수항목을 입력해주세요</AccountExplanation>
			<InputInfo>아이디</InputInfo>
			<SignUpIdInput ref={IdRef} isClicked={isClicked} setIsClicked={setIsClicked} className='IdInput' placeholder='아이디를 입력해주세요' type='text' clickCountFn={clickCountFn} clickFn={duplicateCheck} text='중복확인'/>
			<AccountExplanation ref={IdPlanationRef}>{idPlanation}</AccountExplanation>
			<InputInfo>비밀번호</InputInfo>
			<SignUpPwInput ref={PWRef} className='PWInput' placeholder='사용자의 비밀번호를 입력해주세요' type='password' clickCountFn={clickCountFn} />
			<AccountExplanation ref={PwPlanationRef}>필수항목을 입력해주세요</AccountExplanation>
		</TopLevelWrapper>
	)
})

export default SignUpInfo1;

const startAnimation = keyframes`
	0% { opacity: 0; transform: translateX(150%); }
	10% { opacity: 0.1; transform: translateX(130%); }
	20% { opacity: 0.2; transform: translateX(100%); }
	30% { opacity: 0.3; transform: translateX(70%); }
	40% { opacity: 0.4; transform: translateX(40%); }
	50% { opacity: 0.5; transform: translateX(20%); }
	60% { opacity: 0.6; transform: translateX(0%); }
	70% { opacity: 0.7;}
	80% { opacity: 0.8; }
	90% { opacity: 0.9;}
	100% { opacity: 1;}
`;


const TopLevelWrapper = styled.div`
	position: absolute;
	display: flex;
	
	flex-direction: column; 
	justify-content: flex-start;

	width: 468px;
	// width: max(271px, 24.375vw);
	// width: max(250px, 24.375vw);
	// height: 281px;

	margin-top: 145px;
	// margin-top: max(106px, 8.28125vw);

	background-color: rgba(255, 255, 255, 1);

	opacity: 0;
	z-index: 1;
	transform: translateX(150%);

	animation: none;

	${(props) =>
		props.$animate &&
		css`
			animation: ${startAnimation} 0.5s ease-out;
	`}

	transition: all 0.3s ease-in-out;
`;

const InputInfo = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	// font-size: max(12px, 0.7291666666666667vw);
	// line-height: 20px;
	
	margin: 19px 0 0 0;
	// margin-top: max(11.73px, 0.9895833333333333vw);
	// margin-right: 0px;
	// margin-bottom: 0px;
	// margin-left: 0px;

	cursor: default;
`;

const AccountExplanation = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	// font-size: max(12px, 0.625vw);
	// line-height: 17.38px;

	// color: ${props => props.bold ? `#FF3131` : `#33C8FF`};
	color: #FF3131;

	margin: 4px 0 0 0;

	opacity: 0;

  transition: all 0.5s ease-in-out;
`;

